import Vue from "vue";
class ProjectService {
  Remove(id) {
    return Vue.prototype.$http({
      url: "project/remove/" + id,
      method: "DELETE"
    });
  }

  Get(id) {
    return Vue.prototype.$http({
      url: "project/get/" + id,
      method: "GET"
    });
  }

  GetCoordinates(id) {
    return Vue.prototype.$http({
      url: "project/get-coordinates/" + id,
      method: "GET"
    });
  }

  GetNextSequence(id) {
    return Vue.prototype.$http({
      url: "project/get-next-sequence/" + id,
      method: "GET"
    });
  }

  New(viewModel) {
    return Vue.prototype.$http({
      url: "project/new",
      data: viewModel,
      method: "POST"
    });
  }

  Edit(viewModel) {
    return Vue.prototype.$http({
      url: "project/edit",
      data: viewModel,
      method: "PUT"
    });
  }

  GetGrid(page) {
    return Vue.prototype.$http({
      url: "/project/get-grid/" + page + "/20",
      method: "GET"
    });
  }

  GetVSelect(term, isGaau) {
    return Vue.prototype.$http({
      url: "/project/get-v-select?isGaau=" + isGaau + "&term=" + term,
      method: "GET"
    });
  }

  ReportTableUpdate(projectId, file) {
    let formData = new FormData();
    formData.append("file", file);
    // formData.append("projectId", projectId);

    return Vue.prototype.$http({
      url: "project/report/table/update/" + projectId,
      data: formData,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
}

export default new ProjectService();
